import { withProfiler } from "@sentry/react";

interface Props {
  storeAttributes: {
    storeId: string;
    storeName: string;
    storeLogo: string;
  };
  analyticsAnonymousId: string;
}

const OfficeResendInvitationPage = ({ storeAttributes }: Props) => {
  return (
    <p>{`Hello there, this is where you'll be able to resend an invitation in ${storeAttributes.storeName}`}</p>
  );
};

const PatientInvitationPageWithProfiler = withProfiler(OfficeResendInvitationPage);
export { PatientInvitationPageWithProfiler as OfficeResendInvitationPage };
